import { Label, Grid } from "semantic-ui-react";
import AccordionItem from "./AccordionItem";
import { Slider } from "react-semantic-ui-range";
import { SettingsContext } from '../context'
import { useContext } from 'react'


function Lighting() {

  const { lightingObj, setLightingObj } = useContext(SettingsContext);

  const handleLightingObj = (item, value) => {
    const newState = lightingObj.map(obj => {
      if (obj.name === item) return { ...obj, value: value };
      return obj;
    });

    let modelViewer = document.getElementById("modelViewer");
    modelViewer.exposure = lightingObj[0].value;
    modelViewer.shadowIntensity = lightingObj[1].value;
    modelViewer.shadowSoftness = lightingObj[2].value;
    return setLightingObj(newState);

  }

  return (
    <div>
      <AccordionItem header="Lighting">
        <div className="accordion">
          <Grid columns="three" divided>
            <Grid.Row>
              <Grid.Column width={4}>
                <label className="text">Exposure</label>
              </Grid.Column>
              <Grid.Column width={9}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  settings={{
                    start: lightingObj[0].value ? parseFloat(lightingObj[0].value) : 1.0,
                    max: 2,
                    step: 0.01,
                    min: 0,
                    default: 2,
                    onChange: (value) => {
                      handleLightingObj("Exposure", value)
                    },
                  }}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <div>
                  {" "}
                  <Label color="blue">{lightingObj[0].value ? lightingObj[0].value : 1}</Label>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={4}>
                <label className="text">Shadow</label>
              </Grid.Column>
              <Grid.Column width={9}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  settings={{
                    start: lightingObj[1].value ? parseFloat(lightingObj[1].value) : 1,
                    max: 2,
                    step: 0.01,
                    min: 0,
                    onChange: (value) => {
                      handleLightingObj("Shadow", value)
                    },
                  }}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <div>
                  {" "}
                  <Label color="blue">{lightingObj[1].value ? parseFloat(lightingObj[1].value) : 1}</Label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <label className="text">Shadow Softness</label>
              </Grid.Column>
              <Grid.Column width={9}>
                <Slider
                  color="blue"
                  style={{
                    trackFill: { backgroundColor: "#3498db" },
                  }}
                  inverted={false}
                  settings={{
                    start: lightingObj[2].value ? parseFloat(lightingObj[2].value) : 1,
                    max: 2,
                    step: 0.01,
                    min: 0,
                    onChange: (value) => {
                      handleLightingObj("shadow-softness", value)
                    },
                  }}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <div>
                  {" "}
                  <Label color="blue">{lightingObj[2].value ? lightingObj[2].value : 1}</Label>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </AccordionItem>
    </div>
  );
}
export default Lighting;
